class JavaScriptInjectedSection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Getting the parent under which we need to show the menu
    this.targetLocationSelector = this.dataset['targetLocation'];
    this.targetLocation = document.querySelector(this.targetLocationSelector);

    // Move the nodes rather than copying innerHTML, so the markup isn't re-parsed and doesn't
    // stay in the page twice (duplicate DOM nodes and ids).
    if(this.targetLocation) {
      this.targetLocation.replaceChildren(...this.childNodes);
    }
  }
}

customElements.define('javascript-injected-section', JavaScriptInjectedSection);

class JavaScriptInjectedSectionHamburger extends JavaScriptInjectedSection {
  constructor() {
    super();
  }

  connectedCallback() {
    document.querySelector('header-drawer').bindEvents();
  }
}

customElements.define('javascript-injected-section-hamburger', JavaScriptInjectedSectionHamburger);